// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"search_main-module__searchContainer--wKKuI","filtersOpen":"search_main-module__filtersOpen--1p3f0"};